import React, { useContext, useState } from "react";
import { ButtonProps, CommandBarButton, Aside, CodedProperty } from "sprint-common-web";

import { ManageAncillaryContext } from "../../context/ManageAncillaryContext";
import { AncillaryItem } from "../AncillaryItem";
import { CreateAncillaryForm } from "../create-ancillary-form/CreateAncillaryForm";

export interface AddAncillaryButtonProps extends ButtonProps {
    pageSize: number;
}

export const AddAncillaryButton: React.FC<AddAncillaryButtonProps> = (props: AddAncillaryButtonProps) => {
    const [isSidebarDisplayed, setIsSidebarDisplayed] = useState<boolean>(false);

    const { ancillaryItems, addAncillaryItem } = useContext(ManageAncillaryContext);

    const closeSidebar = () => {
        setIsSidebarDisplayed(false);
    };

    const openSidebar = () => {
        setIsSidebarDisplayed(true);
    };

    const handleFormSubmit = (newItem: AncillaryItem) => {
        closeSidebar();
        if (ancillaryItems.length >= props.pageSize) ancillaryItems.pop();

        addAncillaryItem({
            id: newItem.id,
            title: newItem.title,
            orphaned: newItem.orphaned,
            source: newItem.source,
            versionType: {
                id: newItem.versionType.id,
                name: newItem.versionType.name
            },
            distributor: newItem.distributor,
            airlines: getAirlines(newItem.airlines)
        });
    };

    return (
        <>
            <CommandBarButton onClick={openSidebar} text="Add" icon="Add" disabled={props.disabled} />
            <Aside isOpen={isSidebarDisplayed} type="form" headerText="Add Ancillary" onDismiss={closeSidebar}>
                <CreateAncillaryForm onCancel={closeSidebar} onSubmit={handleFormSubmit} />
            </Aside>
        </>
    );
};

const getAirlines = (airlines: CodedProperty[]): CodedProperty[] => {
    return airlines.map((airline) => ({
        id: airline.id,
        name: airline.name,
        code: airline.code
    }));
};
